/* 布局 */
//前台
import Layout from "@views/layout";

const driverusermessageRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "driverusermessage/list",
        name: "DRIVERUSERMESSAGE",
        meta: {
            title: "司机通知消息",
            keepAlive:true
        },
        component: () => import("@views/business/driverusermessage/index.vue"),
    },
        ],
};

export default driverusermessageRouter;
